import { TreeNode } from "./user-select.interface";
import { DepartmentSimpleListReq } from "@/views/organization/department/department.interface";
import { DepartmentService } from "@/views/organization/department/department.service";

const UNIQ_FLAG = "__";

export class UserSelectService {
  static async fetchDepartmentRecords(parentId: string,data?): Promise<TreeNode[]> {
    const params = new DepartmentSimpleListReq();
    params.merge({ parentId, needChildren: true, needEmployee: true,...data });
    const records = await DepartmentService.fetchSimpleList(params);
    return records.map((department) => {
      const { id, name, isLeaf ,hasChildren,hasEmployee} = department;
      return {
        id,
        name,
        isLeaf,
        hasChildren,
        selectable: false,
        hasEmployee,
        children: [],
        isDepartment:true,
      };
    });
  }

  static async fetchUserRecords(data,departmentId,staffType?): Promise<TreeNode[]> {
    const records = await DepartmentService.fetchUserList(data,departmentId,staffType);
    return records.map((user) => {
      const { tenantUserId, realName,mobile } = user;
      return {
        // id: UserSelectService.generateUniqUserId(departmentId, tenantUserId),
        id:tenantUserId,
        name: realName,
        isLeaf: true,
        hasChildren:false,
        selectable: true,
        isDepartment:false,
        mobile:mobile
      };
    });
  }

  static async fetchRecords(data,departmentId,staffType?) {
    const isRoot = departmentId === 0;
    const departmentRecords = await UserSelectService.fetchDepartmentRecords(departmentId,data);
    if (isRoot) {
      return departmentRecords;
    }

    const userRecords = await UserSelectService.fetchUserRecords(data,departmentId,staffType);
    return [...departmentRecords, ...userRecords];
  }

  static generateUniqUserId(departmentId, userId) {
    return `${departmentId}${UNIQ_FLAG}${userId}`;
  }

  static parseUserId(uniqUserId) {
    const temp = uniqUserId.split(UNIQ_FLAG);
    if (temp.length === 2) {
      return temp[1];
    }
    return uniqUserId;
  }
}
